<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-time`]" width="1em" height="1em" v-bind="$attrs"><rect x="2.579" y="3.523" width="18.841" height="16.957" rx="5" stroke="#165DFF" stroke-width="1.66" stroke-linejoin="round"/><path d="M12 7.28906V11.9994L15.2972 15.2966" stroke="#00BBD8" stroke-width="1.66" stroke-linecap="round" stroke-linejoin="round"/></svg>
</template>
<script>

export default {
  name: 'IconColorTime',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
